<template>
    <div class="thousand_layout" id="VaultMgtBox">

        <div class="right_box">
            <div class="flex_layout_between">
                <h3>{{$t('vault.CardHobbyVault')}}</h3>
            </div>

            <div class="breadcrumb">
                <router-link class="text_gray" :to="{ path: '/vault/buyerpanel'}">{{$t('vault.CardHobbyVault')}}</router-link> 
                <span class="el-icon-arrow-right text_gray"></span> 
                {{$t('vault.SubmittoVault')}}</div>
            <div style="    position: relative;">
            <div class="bids_tabs">
                <div class="on"><router-link :to="{ path: '/vault/StockInMgt/'+vaultWareId }">{{$t('vault.SubmittoVault')}}</router-link></div>
                <div><router-link :to="{ path: '/vault/myvault/'+vaultWareId }">{{$t('vault.InVault')}}</router-link></div>
                <div><router-link :to="{ path: '/vault/OutboundList/'+vaultWareId }">{{$t('vault.WithdrawfromVault')}}</router-link></div>
            </div>
            
            <div class="tab-mgt-btns" style="position: absolute;top: 5px;right: 0;">
                    <router-link class="tab-btn add-stockin" :to="{ path: '/vault/StockInApply/'+vaultWareId }">
                        <span>{{$t('vault.CreateVaultSubmission')}}</span>
                    </router-link>
                    <!-- <a href="/vault/StockInApply" class="tab-btn add-stockin"><span>添加入库申请</span></a> -->
                </div>
            </div>
            <div class="tab_stock">
                <div class="search-box" v-if="showSearchFilter()">
                    <!-- @*未寄出 = 0, 已寄出 = 1, 已签收 = 2, 已查验 = 3,*@ -->
                    <el-select class="search-block" v-model="searchForm.Status" 
                        v-on:change="searchForm.PageIndex = 1; GetVaultList()">
                        <el-option v-for="item in cardStatus" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <!-- <el-select class="search-block" v-model="searchForm.ValutId" placeholder="卡淘Vault仓"
                        v-on:change="searchForm.PageIndex = 1; GetVaultList()">
                        <el-option label="全部仓" value="">
                        </el-option>
                        <el-option v-for="(item, index) in vaultList" :key="index" :label="item.ValutName"
                            :value="item._id">
                        </el-option>
                    </el-select> -->
                    <!-- @*<el-input class="search-block search-keyword input-with-select" placeholder="请输入标题" v-model="searchForm['Title']" :clearable="true" v-on:keyup.enter.native="searchForm['PageIndex'] = 1; GetVaultList()">
                    <el-button slot="append" icon="el-icon-search" v-on:click="searchForm['PageIndex'] = 1; GetVaultList()"></el-button>
                </el-input>*@ -->
                </div>
            </div>
            <div class="vault_list_box" v-if="list.length">
                <div class="headlist">
                    <div class="first">{{ $t('base.item') }}</div>
                    <div>{{ $t('base.quantity') }}</div>
                    <div>{{ $t('base.status') }}</div>
                    <div>{{ $t('base.operate') }}</div>
                </div>
                <div class="content_list" v-for="(obj, key) in list" v-bind:key="key">
                    <div class="first pickupCard">
                        
                        <div class="pickupCardImg">
                            <div class="v-image" v-on:click="cardEdit(obj, 'view')">
                                <template v-if="obj.Imgs.length">
                                    <el-image
                                        :class="['cover-image', 'cover-image-' + key, 'cover-image-' + (obj.Imgs.length > 1 ? (key === 0 ? 'first' : 'other') : 'single')]"
                                        v-for="(cImg, key) in obj.Imgs" v-bind:key="key" v-if="key < 3"
                                        :src="cImg + '?imageView2/2/h/210'" fit="contain"></el-image>
                                </template>
                            </div>
                        </div>
                        <div class="pickupCardText">
                            <div class="v-title">
                                {{ obj.Code }}&nbsp;&nbsp;
                            </div>
                            <div class="v-des">
                                <div v-if="0" class="grade-box">
                                    <div class="grade-block" v-for="(G, gkey) in obj.Details" v-bind:key="gkey"
                                        v-show="gkey < 3">
                                        <span class="grade">{{ G.ProfessionalGrader }}</span>
                                        {{ G.CertificationNumber }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>x {{ obj.Details.length }}</div>
                    <div :class="['vStatus','vStatus-'+obj.Status]">{{cardStatusSet(obj.Status)}}</div>
                    <div class="last">
                        <div v-if="obj.Status === 0" :class="['v-btn', 'v-btn-ship']" v-on:click="showShipDialog(obj)">{{$t('vault.Ship')}}</div>
                        <div v-if="[1].includes(obj.Status) && obj.ReturnInfos.length > 0" :class="['v-btn']"v-on:click="showShipDialog(obj)">{{$t('vault.EditShipment')}}</div>
                        <div :class="['v-btn', 'v-btn-view']" v-on:click="cardEdit(obj, 'view')">{{ $t('base.viewDetails') }}</div>
                        <!-- @*<div :class="['v-btn', 'v-btn-view']" v-on:click="showDetail(obj)">详情[弹框]</div>*@ -->
                        <div v-if="[0].includes(obj.Status)" :class="['v-btn', 'v-btn-edit']"v-on:click="cardEdit(obj, 'edit')">{{ $t('base.edit') }}</div>
                        <div v-if="[0].includes(obj.Status)" :class="['v-btn', 'v-btn-delt']"v-on:click="DelVaultItem(obj)">{{ $t('base.delete') }}</div>
                    </div>
                </div>
                <!-- @* 分页 *@` -->
                <!-- <div class="list-pagination">
                    <el-pagination background v-on:current-change="currentChange" v-on:size-change="sizeChange"
                        :current-page.sync="searchForm.PageIndex" :page-size="searchForm.PageSize"
                        :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager,next" :total="pageTotal">

                    </el-pagination>
                </div> -->
                
            </div>
            <div v-else>

                <div v-if="loading" class="ls-loading">
                    Loading...
                </div>
                <div v-else class="no-data">
                    <not-null class="notfind" title="" :text="$t('base.noData')" />
                    <!-- <div>{{ searchForm.Status === '' && searchForm.ValutId === '' ? '暂无入库申请' : '暂无记录' }}</div> -->
                    <!-- <div class="tab-mgt-btns" v-if="searchForm.Status === '' && searchForm.ValutId === ''">
                        <router-link class="tab-btn add-stockin" :to="{ path: '/vault/StockInApply' }">
                            <span>{{$t('vault.CreateVaultSubmission')}}</span>
                        </router-link>
                    </div> -->
                        <!-- <a href="/vault/StockInApply" class="tab-btn add-stockin"><span>添加入库申请</span></a> -->
                </div>
            </div>
            

            <list-pagination class="" :TotalCount="pageTotal" :ps="searchForm.PageSize" @ps='sizeChange' @pi='currentChange' />

            <!-- @* #region 发货 *@ -->
            <div v-if="dialogShipVisible">
                <el-dialog :title="$t('vault.Ship')" :visible.sync="dialogShipVisible" width="520px" top="10vh"
                    :before-close="handleShipClose" :close-on-click-modal="false" :close-on-press-escape="false">
                    <div class="dialog-form-box">
                        <!-- @* 发货 Form *@ -->
                        <el-form ref="ShipFormRef" v-bind:model="ShipForm" v-bind:rules="rulesShip">
                            <div class="block-card border-none">
                                <div class="form-block">
                                    <div class="row-step">
                                        <span>{{$t('base.carrierName')}}<em>*</em></span>
                                    </div>
                                    <div class="custom-box">
                                        <el-form-item prop="shipFormSelVal">
                                            <el-select class="vault-select" style="width:100%" v-model="shipFormSelVal"
                                                value-key="ShipperName" name="LogisticsCompany" filterable
                                                data-live-search="true" :placeholder="$t('vault.SelectCarrier')"
                                                v-on:change="handleChangeExp($event)">
                                                <el-option v-for="(item, index) in expressList" v-bind:key="index"
                                                    v-bind:label="item.ShipperName" v-bind:value="item">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </div>

                                <div class="form-block">
                                    <div class="row-step">
                                        <span>{{$t('base.trackingNumber')}}<em>*</em></span>
                                    </div>
                                    <div class="custom-box">
                                        <el-form-item prop="TrackingNumber">
                                            <el-input type="text" class="form-input"
                                                v-model="ShipForm['TrackingNumber']" placeholder=""></el-input>
                                        </el-form-item>
                                    </div>
                                </div>

                                <template v-if="itemDetail.VaultConsigneeAddress">
                                
                                    <div class="form-block">
                                        <div class="detail-block-title">
                                            <span>{{itemDetail.ValutEnName}}</span>
                                            <div class="block-subtitle">{{$t('vault.notAcceptPay')}}</div>
                                        </div>
                                        <div class="dtl-row flex">
                                            <div class="dtl-label">
                                                {{ itemDetail.VaultConsigneeAddress.Province }} 
                                                {{ itemDetail.VaultConsigneeAddress.City }} 
                                                {{ itemDetail.VaultConsigneeAddress.District }} 
                                                {{itemDetail.VaultConsigneeAddress.Address }}
                                            </div>
                                            <div class="dtl-cont"></div>
                                        </div>
                                        <div class="dtl-row flex">
                                            <div class="dtl-label">{{ itemDetail.VaultConsigneeAddress.Contacts }} {{itemDetail.VaultConsigneeAddress.Phone }}</div>
                                            <div class="dtl-cont"></div>
                                        </div>
                                    </div>
                                </template>

                            </div>
                            <div class="applyfor-btn-box">
                                <div class="applyfor-buttons" style="justify-content: space-between;">
                                    <div>
                                        <el-button class="sfl input_border" v-on:click="handleShipClose()">
                                            {{$t('base.cancel')}}
                                        </el-button>

                                    </div>
                                    <div>
                                        <el-button :disabled="submitLoading"
                                            v-bind:class="['submit-btn', submitLoading ? 'submitLoading' : '', 'l-it']"
                                            type="primary" v-on:click="ShipSubmit">
                                            {{$t('base.Submit')}}
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </el-form>

                    </div>
                </el-dialog>
            </div>
            <!-- @* #endregion *@ -->

            <!-- @* #region 查看详情 *@ -->
            <div v-if="dialogDetailVisible">
                <el-dialog :title="`入库单详情`" :visible.sync="dialogDetailVisible" width="600px" top="15vh"
                    :before-close="handleDetailClose" :close-on-click-modal="false" :close-on-press-escape="false">
                    <div class="dialog-form-box">
                        <el-tabs v-model="activeTabName" v-on:tab-click="handleTabClick">
                            <el-tab-pane label="卡片信息" name="first" v-if="itemDetail.Details.length">
                                <!-- @* 卡片信息 *@ -->
                                <template>
                                    <!-- @*<div class="detail-block-title">卡片信息</div>*@ -->
                                    <div class="detail-block">
                                        <div class="dtl-row">
                                            <div class="dtl-label"><span>卡淘Vault仓:</span></div>
                                            <div class="dtl-cont">{{ itemDetail.ValutName }}</div>
                                        </div>
                                        <div class="dtl-row">
                                            <div class="dtl-label"><span>入库申请单号:</span></div>
                                            <div class="dtl-cont">{{ itemDetail.Code }}</div>
                                        </div>
                                        <div class="dtl-row">
                                            <div class="dtl-label"><span>图集:</span></div>
                                            <div class="dtl-cont">
                                                <div class="dtl-card-img dtl-card-img-big"
                                                    v-for="(img, k) in itemDetail.Imgs" v-bind:key="k">
                                                    <el-image class="dtl-img" :src="img + '?imageView2/2/h/100'"
                                                        fit="contain" :preview-src-list="itemDetail.Imgs">
                                                    </el-image>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="dtl-row">
                                            <!-- @*<div class="dtl-label"><span>卡片信息:</span></div>*@ -->
                                            <div class="dtl-cont fill">
                                                <el-table :data="itemDetail.Details" style="width: 100%" height="250">
                                                    <el-table-column label="卡片">
                                                        <template slot-scope="scope">
                                                            <span class="dtl-card-grader">{{
                        scope.row.ProfessionalGrader }}</span><span>{{
                        scope.row.CertificationNumber }}</span>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="状态" width="180">
                                                        <template slot-scope="scope">
                                                            <span
                                                                :class="['card-status', 'card-status-' + scope.row.Status]">{{
                        scope.row.StatusMsg }}</span>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                                <div v-if="itemDetail.Status == 3 && checkReturnCard(itemDetail.Details)"
                                                    class="btn-view-info">
                                                    查看问题
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </el-tab-pane>
                            <el-tab-pane label="退回地址" name="second" v-if="itemDetail.ReturnInfos.length">
                                <!-- @* 退回地址 *@ -->
                                <template>
                                    <!-- @*<div class="detail-block-title">退回地址</div>*@ -->
                                    <div class="addr-block" v-for="(obj, k) in itemDetail.ReturnInfos" :key="k">
                                        <div class="dtl-row">
                                            <div class="dtl-label"><span>联系人:</span></div>
                                            <div class="dtl-cont">{{ obj.Contacts }}</div>
                                        </div>
                                        <div class="dtl-row">
                                            <div class="dtl-label"><span>电话号:</span></div>
                                            <div class="dtl-cont">{{ obj.Phone }}</div>
                                        </div>
                                        <div class="dtl-row">
                                            <div class="dtl-label"><span>退回地址:</span></div>
                                            <div class="dtl-cont">
                                                {{ obj.Province }}-{{ obj.City }}-{{ obj.District }}-
                                                <div>{{ obj.Address }}</div>
                                            </div>
                                        </div>
                                        <div class="dtl-row" v-if="itemDetail.ReturnCard[obj.Id]">
                                            <div class="dtl-label"><span>退回卡片:</span></div>
                                            <div class="dtl-cont">
                                                <template v-if="itemDetail.ReturnCard && itemDetail.ReturnCard[obj.Id]">
                                                    <div class="dtl-card-ls"
                                                        v-for="(card, kk) in itemDetail.ReturnCard[obj.Id]"
                                                        v-bind:key="kk">
                                                        <span class="dtl-card-grader">{{ card.ProfessionalGrader
                                                            }}</span><span>{{ card.CertificationNumber }}</span>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="dtl-card-ls">无退回卡片</div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </el-tab-pane>
                            <el-tab-pane label="发货单" name="third" v-if="itemDetail.TrackingNumber">
                                <!-- @* 发货单 *@ -->
                                <template>
                                    <!-- @*<div class="detail-block-title">发货单</div>*@ -->
                                    <div class="detail-block">
                                        <div class="dtl-row">
                                            <div class="dtl-label"><span>快递公司:</span></div>
                                            <div class="dtl-cont">{{ itemDetail.LogisticsCompany }}</div>
                                        </div>
                                        <div class="dtl-row">
                                            <div class="dtl-label"><span>快递单号:</span></div>
                                            <div class="dtl-cont">{{ itemDetail.TrackingNumber }}</div>
                                        </div>
                                    </div>
                                </template>
                            </el-tab-pane>
                        </el-tabs>




                    </div>
                </el-dialog>
            </div>
            <!-- @* #endregion *@ -->

        </div>
    </div>
</template>

<script>
import VaultStockInMgt from './js/vue-VaultStockInMgt.js';

export default {
    ...VaultStockInMgt
};
</script>



<style scoped>
@import "../../../static/css/usertabslist.css";
@import "../../../static/css/vault/vault.css";
@import "../../../static/css/vault/stockInMgt.css";
</style>


// WEBPACK FOOTER //
// src/pages/Vault/StockInMgt.vue